<template>
    <div class="my-4 text-center">
        <VueRecaptcha v-if="!hasErrors" :sitekey="siteKey"
            @verify="verifyMethod"
            @expired="expiredMethod"
            @render="renderMethod"
            @error="errorMethod"
            :size="getRecaptchaSize"
            :language="'en'">
        </VueRecaptcha>
    </div>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';

export default {
    name: "Recaptcha",
    components: { VueRecaptcha },
    props: {
        invisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const siteKey = process.env.MIX_RECAPTCHA_SITE_KEY;
        return {
            hasErrors: false,
            isValid: false,
            siteKey
        }
    },
    methods: {
        verifyMethod(token) {
            this.isValid = true;
            this.emitMethodToParent();
        },
        expiredMethod() {
            this.isValid = false;
            this.emitMethodToParent();
        },
        renderMethod() {
        },
        errorMethod() {
            this.hasErrors = true;
            this.emitMethodToParent();
        },
        emitMethodToParent() {
            this.$emit('recaptchaValueChange', this.hasErrors || this.isValid);
        }
    },
    computed: {
        getRecaptchaSize() {
            return this.invisible ? 'invisible' : 'normal';
        },
    }
}
</script>

<style scoped>

</style>
